import { useEffect } from "react";

import Footer from "../components/Footer";
import InstituteHero from "../components/institute/InstituteHero";
import CourseNavigation from "../components/institute/CourseNavigation";
import CourseIntro from "../components/institute/CourseIntro";
import LearningBenefits from "../components/institute/LearningBenefits";
import InstituteCTA from "../components/institute/InstituteCTA";
import {
  MernStackSection,
  DigitalMarketingSection,
  UiUxSection,
  PythonFullStackSection,
  TallyPrimeSection,
  BasicComputersSection,
  CyberSecuritySection,
} from "../components/institute/InstituteCourses";

export default function Institute() {
  useEffect(() => {
    document.title = "IT Training Institute in Karaikudi | WE3X Institute";

    let meta = document.querySelector('meta[name="description"]');

    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.content =
      "Join WE3X Institute in Karaikudi for practical IT courses including MERN Stack, Python Full Stack, Digital Marketing, UI/UX, Cyber Security, Tally Prime and Basic Computers.";
  }, []);

  return (
    <main className="overflow-hidden bg-[#f6f6f6] text-[#111111]">
      <InstituteHero />
      <CourseNavigation />
      <CourseIntro />

      <MernStackSection />
      <DigitalMarketingSection />
      <UiUxSection />
      <PythonFullStackSection />
      <TallyPrimeSection />
      <BasicComputersSection />
      <CyberSecuritySection />

      <LearningBenefits />
      <InstituteCTA />
      <Footer />
    </main>
  );
}
